@if (!isMobileView) {
  <tr class="table-row">
    <th
      class="sticky text-left align-middle left-0 min-w-64 px-3"
      scope="row"
      [id]="
        (question.title | toValidId) +
        (matrixQuestionId ? '-' + matrixQuestionId : '')
      "
    >
      <span [innerHTML]="question.title | safeHtml"></span>
    </th>
    @if (
      question.presentation === "VERTICAL" ||
      question.presentation === "HORIZONTAL"
    ) {
      @for (alternative of question.alternatives; track $index) {
        <app-single-select-radio-button
          [question]="question"
          [alternative]="alternative"
          [control]="control"
          [otherControl]="otherControl"
          [inTable]="true"
          [cellHeaders]="
            (question.title | toValidId) +
            (matrixQuestionId ? '-' + matrixQuestionId : '') +
            ' ' +
            (alternative.title | toValidId) +
            (matrixQuestionId ? '-' + matrixQuestionId : '')
          "
          class="contents"
          parentTableSelector="app-matrix-single-select"
        ></app-single-select-radio-button>
      }
    } @else if (question.presentation === "SLIDER") {
      <td
        class="align-middle min-w-96"
        [attr.colspan]="question.alternatives.length"
        [attr.headers]="
          (question.title | toValidId) +
          (matrixQuestionId ? '-' + matrixQuestionId : '')
        "
      >
        <app-slider
          [question]="question"
          [control]="control"
          [rowTitle]="question.title"
          [inMatrix]="true"
          class="w-full"
        ></app-slider>
      </td>
    }
  </tr>
}

@if (isMobileView) {
  <div class="block" role="radiogroup">
    <h4 class="font-semibold" [innerHTML]="question.title | safeHtml"></h4>
    @if (
      question.presentation === "VERTICAL" ||
      question.presentation === "HORIZONTAL"
    ) {
      @for (alternative of question.alternatives; track $index) {
        <app-single-select-radio-button
          [question]="question"
          [alternative]="alternative"
          [control]="control"
          [otherControl]="otherControl"
        ></app-single-select-radio-button>
      }
    } @else if (question.presentation === "SLIDER") {
      <app-slider
        [question]="question"
        [control]="control"
        [rowTitle]="question.title"
        class="w-full"
      ></app-slider>
    }
  </div>
}

@if (control?.hasError("required") && control.touched && !hideError) {
  <app-validator
    [question]="question"
    [validator]="ValidatorType.RequiredSelect"
  />
}
